<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
      <div class="w-100 bg-white">
        <span id="top-section"></span>
        <div class="w-100 py-5" v-if="posContext.error != ''">
          <ErrorMessage :message="posContext.error" />
        </div>
        <template v-else>
          <div class="w-100 mb-4" v-if="posContext.is_load">
            <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
          </div>
          <!-- NAVBAR  -->
          <template v-else>
            <div v-if="posContext.show_image" class="w-100 py-3 position-fixed z-index-1040" style="top:0;">
              <div class="ga-container">
                <div class="row">
                  <div class="col-2 align-self-center text-right offset-10">
                    <div class="pos-navbar-icon" @click="posContext.goToPage('PosSearch')" :class="posContext.scroll_p < 90 ? 'active' : ''">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_564_18)">
                          <path
                            d="M0 7.28028C0 11.2945 3.26609 14.5605 7.28028 14.5605C8.86769 14.5605 10.3183 14.0497 11.5135 13.1921L16.002 17.6898C16.2118 17.8997 16.4856 18 16.7775 18C17.3979 18 17.8266 17.5347 17.8266 16.9235C17.8266 16.6315 17.7172 16.3669 17.5256 16.1753L13.0643 11.6868C14.0041 10.4643 14.5605 8.94072 14.5605 7.28028C14.5605 3.26609 11.2945 0 7.28028 0C3.26609 0 0 3.26609 0 7.28028ZM1.56006 7.28028C1.56006 4.12367 4.12367 1.56006 7.28028 1.56006C10.4369 1.56006 13.0005 4.12367 13.0005 7.28028C13.0005 10.4369 10.4369 13.0005 7.28028 13.0005C4.12367 13.0005 1.56006 10.4369 1.56006 7.28028Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_564_18">
                            <rect width="17.8266" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="w-100 position-relative">
            <template v-if="!posContext.is_load">
              <div class="w-100 position-relative" v-if="posContext.show_image">
                <template v-if="posContext.general_data.slider_image.length > 1">
                  <flickity ref="main_slider" :options="posContext.$basic_slider_option" class="spa-product">
                    <div class="carousel-cell w-100" :id="slider_merchant.id"
                      v-for="(slider_merchant,index) in posContext.general_data.slider_image">
                      <div class="w-100" style="height: 200px;">
                        <img @click="posContext.setActiveImage(index)" :src="slider_merchant.image_url"
                          class="img-fit cursor-zoom" :alt="posContext.general_data.name">
                      </div>
                    </div>
                  </flickity>
                </template>
                <template v-else>
                  <div class="w-100" style="height:200px">
                    <img @click="posContext.setActiveImage(0)" :src="posContext.general_data.slider_image[0].image_url" class="img-fit" :alt="posContext.general_data.name">
                  </div>
                </template>
                <CoolLightBox
                  :items="posContext.general_data.slider_image"
                  srcName="image_url"
                  :index="posContext.active_image"
                  closeOnClickOutsideMobile
                  @close="posContext.active_image = null">
                </CoolLightBox>
              </div>
              <div class="ga-container mb-5 position-sticky z-index-1025 pos-top-section" :class="posContext.scroll_p > 150 || !posContext.show_image ? 'top' : ''" style="margin-top: -50px;top:0px;">
                <!-- TOP SECTION -->
                <div
                  class="w-100 bg-white box-shadow-light-aff border-form radius-6 p-3 position-relative z-index-1025">
                  <div class="row align-items-center no-gutters">
                    <div class="col-7" @click="posContext.goToPage('PosDetail')">
                      <p class="mb-0 heading-6-1">{{ posContext.general_data.name }}</p>
                      <p class="mb-0 body-2-4" v-if="posContext.category_position.active.title">{{ posContext.category_position.active.title }}</p>
                      <p class="mb-0 body-3-3" v-else>{{ posContext.general_data.category }}</p>
                    </div>
                    <div class="col-5 text-right no-ws text-right">
                      <div class="d-inline-block align-middle mr-3" v-if="posContext.scroll_p > 150 || !posContext.show_image">
                        <svg @click="posContext.goToPage('PosSearch')" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_564_18)">
                            <path
                              d="M0 7.28028C0 11.2945 3.26609 14.5605 7.28028 14.5605C8.86769 14.5605 10.3183 14.0497 11.5135 13.1921L16.002 17.6898C16.2118 17.8997 16.4856 18 16.7775 18C17.3979 18 17.8266 17.5347 17.8266 16.9235C17.8266 16.6315 17.7172 16.3669 17.5256 16.1753L13.0643 11.6868C14.0041 10.4643 14.5605 8.94072 14.5605 7.28028C14.5605 3.26609 11.2945 0 7.28028 0C3.26609 0 0 3.26609 0 7.28028ZM1.56006 7.28028C1.56006 4.12367 4.12367 1.56006 7.28028 1.56006C10.4369 1.56006 13.0005 4.12367 13.0005 7.28028C13.0005 10.4369 10.4369 13.0005 7.28028 13.0005C4.12367 13.0005 1.56006 10.4369 1.56006 7.28028Z"
                              fill="black" fill-opacity="0.85" />
                          </g>
                          <defs>
                            <clipPath id="clip0_564_18">
                              <rect width="17.8266" height="18" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="d-inline-block align-middle" v-if="posContext.general_data.use_booking_table">
                        <button class="g-btn g-btn-secondary g-btn-sm" @click="posContext.goToPage('PosBookingTable')">Find a table</button>
                      </div>
                      <div class="d-inline-block align-middle" v-else>
                        <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_572_18)">
                            <path
                              d="M11.4609 10.1719C11.4609 9.87891 11.3438 9.60938 11.1211 9.39844L1.83984 0.304688C1.62891 0.105469 1.37109 0 1.06641 0C0.46875 0 0 0.457031 0 1.06641C0 1.35938 0.117188 1.62891 0.304688 1.82812L8.83594 10.1719L0.304688 18.5156C0.117188 18.7148 0 18.9727 0 19.2773C0 19.8867 0.46875 20.3438 1.06641 20.3438C1.37109 20.3438 1.62891 20.2383 1.83984 20.0273L11.1211 10.9453C11.3438 10.7227 11.4609 10.4648 11.4609 10.1719Z"
                              fill="#222222" />
                          </g>
                          <defs>
                            <clipPath id="clip0_572_18">
                              <rect width="11.4609" height="20.3555" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <block v-if="!posContext.show_image" :height="16" />
            </template>

            <div class="ga-container">

              <!-- RECOMMENDED PRODUCT -->
              <template v-if="posContext.is_load_product_best">
                <b-skeleton width="40%" height="30px" class="mb-4"></b-skeleton>
                <div class="row">
                  <div class="col-6 mb-4" v-for="i in 5">
                    <div class="mb-2 radius-6" style="overflow: hidden;">
                      <b-skeleton-img no-aspect height="150px"></b-skeleton-img>
                    </div>
                    <b-skeleton width="70%" height="24px" class="mb-1"></b-skeleton>
                    <b-skeleton width="40%" height="21px" class="mb-2"></b-skeleton>
                    <b-skeleton width="100%" height="31px"></b-skeleton>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="w-100 mb-5 category">
                  <span id="product-best"></span>
                  <p class="mb-4 heading-6-1">Best Seller</p>
                  <div class="row">
                    <div class="col-6 mb-4" v-for="best_product in posContext.product_best">
                      <Product type="square" :data="best_product" :config-data="posContext.general_data" />
                    </div>
                  </div>
                </div>
              </template>

              <!-- ALL PRODUCT -->
              <template v-if="posContext.is_load_product_list">
                <b-skeleton width="40%" height="30px" class="mb-4"></b-skeleton>
                <div class="w-100 mb-4" v-for="i in 5">
                  <div class="row no-gutters">
                    <div class="col-4">
                      <div class="w-100 radius-6 position-relative" style="height: 110px;overflow: hidden;">
                        <b-skeleton-img no-aspect height="110px"></b-skeleton-img>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="pl-3">
                        <b-skeleton width="50%" height="21.3333px" class="mb-1"></b-skeleton>
                        <b-skeleton width="100%" height="16px" class="mb-1"></b-skeleton>
                        <b-skeleton width="30%" height="18px" class="mb-2"></b-skeleton>
                        <b-skeleton width="30%" height="32px" class="d-table ml-auto"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="w-100 pb-5 category" v-for="category in posContext.product_per_category">
                  <span :id="category.id"></span>
                  <p class="mb-4 heading-6-1">{{ category.name }}</p>
                  <div class="w-100">
                    <div class="mb-4" v-for="(product,product_i) in category.products">
                      <Product type="block" :data="product" :index="product_i" :products_length="category.products.length" :config-data="posContext.general_data" />
                    </div>
                    <template v-if="category.page === 0 && category.has_more">
                      <div class="w-100 mb-4" v-for="i in 3" :key="'skeleton_cat_prod_'+i">
                        <div class="row no-gutters">
                          <div class="col-4">
                            <div class="w-100 radius-6 position-relative" style="height: 110px;overflow: hidden;">
                              <b-skeleton-img no-aspect height="110px"></b-skeleton-img>
                            </div>
                          </div>
                          <div class="col-8">
                            <div class="pl-3">
                              <b-skeleton width="50%" height="21.3333px" class="mb-1"></b-skeleton>
                              <b-skeleton width="100%" height="16px" class="mb-1"></b-skeleton>
                              <b-skeleton width="30%" height="18px" class="mb-2"></b-skeleton>
                              <b-skeleton width="30%" height="32px" class="d-table ml-auto"></b-skeleton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <InfiniteScrollTrigger
                    :has-more="category.has_more"
                    :is-loading="category.is_loading_more"
                    :is-paused="posContext.is_category_jumping"
                    :show-spinner="category.page > 0"
                    @reach="posContext.loadMoreCategoryProducts(category)" />
                </div>
              </template>
            </div>
          </div>

          <div id="category-wrap" class="p-2 bg-danger text-center floating-menu">
            <img src="../../../../../assets/img/icon/food-tray.png" width="30">
            <p class="mb-0 body-2-4 text-white">MENU</p>
          </div>
          <b-popover ref="category_popup" target="category-wrap" triggers="click" placement="lefttop" custom-class="category-wrap">
            <template #title><p class="mb-0 body-1-4 p-3">Category</p></template>
            <div class="w-100 px-3" style="max-height: 400px; overflow-y: auto;">
              <div class="py-3" v-for="(category,category_i) in posContext.category_position.list" :class="{
                'border-b-form': category_i+1 < posContext.category_position.list.length
              }" @click="goToCategory(category.target_id)">
                <p class="mb-0 body-2-1">{{ category.title }}</p>
              </div>
            </div>
          </b-popover>

          <FloatOrderSummary/>
        </template>
      </div>

    </b-col>
  </b-row>
</template>

<script>
  import Product from '@/components/hotel/concierge/pos/Product';
  import FloatOrderSummary from '@/components/hotel/concierge/pos/FloatOrderSummary';
  import InfiniteScrollTrigger from '@/components/v2/InfiniteScrollTrigger';
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
    components: {
      Product,
      FloatOrderSummary,
      InfiniteScrollTrigger,
      CoolLightBox
    },
    inject: ['posContext'],
    methods: {
      goToCategory(id){
        this.posContext.jumpToCategory(behavior => this.scrollToCategory(id, behavior))
        this.$refs.category_popup.doClose()
      },
      scrollToCategory(id, behavior){
        const target = document.getElementById(id)
        if(!target) return
        target.scrollIntoView({ behavior, block: 'start' })
      }
    }
  }

</script>
<style>
  .pos-top-section.top{
    padding-inline: 0px !important;
    transform: scale(1);
  }
  .pos-top-section{
    transition: 0.15s all ease;
    transform: scale(1)
  }
  .pos-top-section.top > div.radius-6{
    border-radius: 0px !important;
  }
  .pos-navbar-icon{
    border-radius: 100%;
    height: 0px;
    width: 40px;
    text-align: center;
    display: grid;
    place-items: center;
    background-color: #fff;
    max-height: 0px;
    transition: max-height 0.3s;
    overflow: hidden;
  }
  .pos-navbar-icon.active {
    height: 40px;
    max-height: 50px;
    border: 1px solid #ccc;
  }
  .floating-menu{
    position: sticky;
    right: 0px;
    bottom: 120px;
    border-radius: 12px 0px 0px 12px;
    box-shadow:  -7px 7px 22px #7d7d7d;
    display: table;
    margin-left: auto;
  }
  .category{
    position: relative;
  }
  .category > span{
    position: absolute;
    top: -100px;
    left: 0px;
  }
  .category-wrap{
    min-width: 200px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
  }
  .category-wrap .popover-header, .category-wrap .popover-body{
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/layouts/PosMobileLayout.vue